import { render } from "./PrcPdf.vue?vue&type=template&id=6558823c&scoped=true"
import script from "./PrcPdf.vue?vue&type=script&lang=js"
export * from "./PrcPdf.vue?vue&type=script&lang=js"

import "./PrcPdf.vue?vue&type=style&index=0&id=6558823c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6558823c"]])

export default __exports__